export default __webpack_public_path__ + "static/avatar-kayi-common-7-9be0758a5d4863bc2a6079ed472fc9ea.png";